/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Payment_Tracking_Empty_DescriptionInputs */

const en_case_payment_tracking_empty_description = /** @type {(inputs: Case_Payment_Tracking_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create the payment conditions to generate the schedule.`)
};

const pt_br2_case_payment_tracking_empty_description = /** @type {(inputs: Case_Payment_Tracking_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie as condições de pagamento para gerar o cronograma.`)
};

/**
* | output |
* | --- |
* | "Create the payment conditions to generate the schedule." |
*
* @param {Case_Payment_Tracking_Empty_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_tracking_empty_description = /** @type {((inputs?: Case_Payment_Tracking_Empty_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Tracking_Empty_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_tracking_empty_description(inputs)
	return pt_br2_case_payment_tracking_empty_description(inputs)
});